// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"70e16385162d6ab8a905","873":"cb2f2a5669b1b4f1f30a"}[chunkId] + ".js";
};